const CLIENTS = [
  {
    name: "Anonybit",
    url: "https://customer-assets.emergentagent.com/job_cybertech-prefects/artifacts/287z3f3n_Anonybit%20Logo.png",
    invert: true,
  },
  {
    name: "Ark",
    url: "https://customer-assets.emergentagent.com/job_cybertech-prefects/artifacts/s4ea1ott_Ark.png",
    invert: false,
  },
  {
    name: "Yellow Metal",
    url: "https://customer-assets.emergentagent.com/job_cybertech-prefects/artifacts/hugzldrv_Yellow%20Metal%20Logo.png",
    invert: true,
  },
  {
    name: "Kontango",
    url: "https://customer-assets.emergentagent.com/job_cybertech-prefects/artifacts/976xnkcz_1%2Bkontango-logo-white-horizontal.png",
    invert: false,
  },
  {
    name: "Salt",
    url: "https://customer-assets.emergentagent.com/job_cybertech-prefects/artifacts/usul757h_Salt_logo_full_color_RGB_final_%281%29.png",
    invert: false,
  },
  {
    name: "Draftboard",
    url: "https://customer-assets.emergentagent.com/job_cybertech-prefects/artifacts/zz2yhmw3_DraftBoardlogo.png",
    invert: false,
  },
  {
    name: "Arbor",
    url: "https://customer-assets.emergentagent.com/job_cybertech-prefects/artifacts/dgx1y7ga_logo-full%20%281%29.png",
    invert: false,
  },
];

function ClientItem({ client }) {
  return (
    <div className="flex items-center justify-center px-10 shrink-0">
      <img
        src={client.url}
        alt={client.name}
        className={`h-8 md:h-10 w-auto object-contain opacity-60 hover:opacity-100 transition-opacity duration-300 ${
          client.invert ? "invert brightness-200" : ""
        }`}
      />
    </div>
  );
}

export default function ClientLogos() {
  return (
    <section data-testid="client-logos" className="py-16 border-y border-white/5 overflow-hidden bg-[#0A0A0B]">
      <p className="text-center text-xs uppercase tracking-[0.2em] text-zinc-600 mb-10 font-medium">
        Trusted by forward-thinking companies
      </p>
      <div className="flex animate-marquee items-center" style={{ width: "max-content" }}>
        {[...CLIENTS, ...CLIENTS, ...CLIENTS].map((client, i) => (
          <ClientItem key={i} client={client} />
        ))}
      </div>
    </section>
  );
}
